"use client";

import * as Sentry from "@sentry/nextjs";
import NextError from "next/error";
import { useEffect } from "react";
import {
  STATSIG_EVENTS,
  ERROR_SHOWN_VALUES,
  createStatsigEvent,
  useRoutePathname,
  useStatsigClient,
} from "@repo/statsig";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  const { logEvent } = useStatsigClient();
  const locationData = useRoutePathname();

  useEffect(() => {
    Sentry.captureException(error);

    // Log error screen shown event
    const event = createStatsigEvent(STATSIG_EVENTS.ERROR_SCREEN_SHOWN, {
      ...locationData,
      error_message: error.message,
      error_digest: error.digest,
      error_type: ERROR_SHOWN_VALUES.UNKNOWN,
    });
    logEvent(event);
  }, [error, logEvent, locationData]);

  return (
    <html>
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
